

<ul class="sidebar-university-list ps-0">
    <li class="sidebar-university-name" *ngFor="let university of universityList; index as i" (click)="getUnivervistyData(university)">
        <i class="flaticon-learning"></i> {{university?.universityName}}
    </li>
</ul>

